<section class="blogs-section">
  <div class="container px-4 lg:px-0">
    <div class="blogs-content">
      <div class="flex justify-between items-end">
        <header class="lg:mb-8">
          <h2 class="form-title">Explore our blog</h2>
          <p class="subtitle">We are always out doing something, but we try and post little snippets of our activity.</p>
        </header>
        <div class="space-x-5 justify-center items-center lg:flex hidden">
          <button
            type="button"
            role="button"
            (click)="goToPrev()"
            class="bg-transparent h-[48px] w-[48px] rounded-full flex justify-center items-center border-[1px] border-[#585C67]"
          >
            <img src="/images/pricing/arrowLeft.svg" alt="" />
          </button>
          <button
            type="button"
            role="button"
            (click)="goToNext()"
            class="bg-[#0284C7] h-[48px] w-[48px] rounded-full flex justify-center items-center border-[1px] border-[#0284C7]"
          >
            <img src="/images/pricing/arrowRight.svg" alt="" />
          </button>
        </div>
      </div>
      <div class="flex items-center lg:pt-8">
        <div class="w-full">
          <div class="blogs-carousel py-8 bg-white">
            <owl-carousel-o [options]="customOptions" #owlCarousel>
              <ng-template carouselSlide *ngFor="let card of cards">
                <div class="blog-card w-full lg:my-8">
                  <!-- Card Image -->
                  <img
                    [src]="card.image"
                    alt="Post Image"
                    class="w-full h-[309px] object-cover rounded-[16px]"
                  />

                  <!-- Card Content -->
                  <div class="p-4">
                    <div class="flex items-center mb-4 w-full justify-between">
                      <div class="flex items-center space-x-3">
                        <img
                          [src]="card.logo"
                          alt="Logo"
                          class="w-[43px] logo"
                        />
                        <div>
                          <h3 class="title">{{ card.title }}</h3>
                          <div class="flex items-center space-x-3">
                            <p class="handle">
                              {{ card.handle }}
                            </p>

                            <p class="time">{{ card.time }}</p>
                          </div>
                        </div>
                      </div>
                      <img
                        src="/images/blog/1.svg"
                        class="google-icon"
                        alt="blog"
                      />
                    </div>
                    <p class="description mb-4">
                      {{ card.text }}
                    </p>
                  </div>
                </div>
              </ng-template>
            </owl-carousel-o>
          </div>
        </div>
      </div>
      <div class="flex space-x-5 justify-center items-center pb-4">
        <button
          type="button"
          role="button"
          (click)="goToPrev()"
          class="bg-transparent h-[48px] w-[48px] rounded-full flex justify-center items-center border-[1px] border-[#585C67]"
        >
          <img src="/images/pricing/arrowLeft.svg" alt="" />
        </button>
        <button
          type="button"
          role="button"
          (click)="goToNext()"
          class="bg-[#0284C7] h-[48px] w-[48px] rounded-full flex justify-center items-center border-[1px] border-[#0284C7]"
        >
          <img src="/images/pricing/arrowRight.svg" alt="" />
        </button>
      </div>
    </div>
  </div>
</section>
